<template>
  <MessageBoxBase
    class="js-validation-error com_message-box--error"
  >
    <slot />
  </MessageBoxBase>
</template>

<script>
import MessageBoxBase from '@/components/MessageBoxBase.vue'

export default {
  name: 'MessageBoxError',

  components: {
    MessageBoxBase,
  },
}
</script>
